import React, { useState } from 'react'
import { TextField } from '@material-ui/core'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import useStyles from './styles'

const filter = createFilterOptions()

export const FreeSolo = (props) => {
  const classes = useStyles()
  const { form, prop, label, options, required, placeholder } = props
  const [inputValue, setInputValue] = useState('')
  const [highlightError, setHighlightError] = useState(false)

  const handleInputChange = (event, newValue) => {
    setInputValue(newValue)
    // Desativa highlight se entrada permitida
    if (newValue === form.formState.values[prop]) {
      setHighlightError(false)
    }
  }

  const handleBlur = () => {
    // Verifica se input é igual ao state
    if (inputValue !== form.formState.values[prop]) {
      setHighlightError(true)
    } else {
      setHighlightError(false)
    }
  }
  return (
    <>
      <Autocomplete
        value={form.formState.values[prop] || ''}
        name={prop}
        noOptionsText="Sem informações"
        options={options.map((option) => (option.nome ? { label: option.nome } : { label: option }))}
        onInputChange={handleInputChange}
        onBlur={handleBlur}
        onChange={(event, newValue) => {
          if (!newValue) {
            form.handleChangeNewValueByNameProperty(event, null, prop)
          } else {
            if (typeof newValue === 'string') {
              form.handleChangeNewValueByNameProperty(event, newValue, prop)
            } else if (newValue && newValue.inputValue) {
              // Altera o valor do campo para o valor digitado pelo usuário
              form.handleChangeNewValueByNameProperty(event, newValue.inputValue, prop)
            } else {
              form.handleChangeNewValueByNameProperty(event, newValue.label, prop)
            }
          }
        }}
        getOptionLabel={(option) => {
          // Se for uma opção padrão
          if (typeof option === 'string') {
            return option
          }
          // Se for uma opção criada pelo usuário
          if (option.inputValue) {
            return option.label
          }
          // Opção normal
          return option.label
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params)
          const { inputValue } = params
          // Mostra a opção de adicionar um item não existente
          const isExisting = options.some((option) => inputValue === option)
          if (inputValue !== '' && !isExisting) {
            filtered.push({ inputValue, label: `Adicionar "${inputValue}"` })
          }
          return filtered
        }}
        freeSolo
        renderInput={(params) => <TextField {...params} required={required} variant="outlined" placeholder={placeholder || form.formState.values[prop] || 'Selecionar...'} label={label} InputLabelProps={{ shrink: true }} className={highlightError && required ? classes.highlightError : ''} />}
      />
    </>
  )
}
